/* ============================================================================
   Welcome (deprecated public landing)
   ----------------------------------------------------------------------------
   The marketing landing was removed in v1.1.4. Visits to /welcome now redirect
   straight to /signup (which doubles as sign-in for existing emails). Old
   bookmarks, deep-links, and post-OAuth redirects still resolve.
   ========================================================================= */
import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@/components/AuthProvider";

export default function Welcome() {
  const { isSignedIn, account, isRestoring } = useAuth();
  const [, setLocation] = useLocation();
  useEffect(() => {
    if (isRestoring) return;
    // Signed in goes home, trainer name or not: the trainer step opens over
    // the app, from the ProfileGate (lib/profileSetupRequest).
    if (isSignedIn && account) {
      setLocation("/", { replace: true });
      return;
    }
    setLocation("/signup", { replace: true });
  }, [isSignedIn, account, isRestoring, setLocation]);
  return null;
}
